import { NgModule } from '@angular/core';
import { StayPriceTabComponent } from "./stay-price-tab.component";
import { CommonModule } from "@angular/common";
import { MatTableModule } from "@angular/material/table";
import { PriceModule } from "libraries/component/price/price.module";
import { TravellerNamePipe } from "./pipes/traveller-name.pipe";
import { TravellerPricePipe } from "./pipes/traveller-price.pipe";
import { HeaderClassPipe } from "./pipes/header-class.pipe";
import { ColsHeaderMappingService } from "./service/cols-header-mapping.service";
import { TravellerDataTranslationModule } from "libraries/service/traveller-data-translation/traveller-data-translation.module";
import { RowsMappingService } from "./service/rows-mapping.service";
import { StaySummaryModule } from "../../../sectors/components/sectors-stay/stay-summary/stay-summary.module";
import { MultiselectModule } from "libraries/module/formbuilder/fields/multiselect/multiselect.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { FieldDescriptionModule } from "libraries/module/formbuilder/fields/form-field/components/field-description/field-description.module";
import { ClickOutsideModule } from "libraries/ui_clickOutside/clickOutside.module";

@NgModule({
    imports: [
        ClickOutsideModule,
        CommonModule,
        FieldDescriptionModule,
        FontAwesomeModule,
        MatTableModule,
        MultiselectModule,
        PriceModule,
        StaySummaryModule,
        TravellerDataTranslationModule,

    ],
    exports: [
        StayPriceTabComponent,
        HeaderClassPipe,
        // Warning ! Pas moyen de mettre ce pipe dans Shared (il est utilisé par stay-price-tab & vehicle-rental-price
    ],
    declarations: [
        StayPriceTabComponent,
        TravellerNamePipe,
        TravellerPricePipe,
        HeaderClassPipe,
    ],
    providers: [
        ColsHeaderMappingService,
        RowsMappingService,
    ],
})
export class StayPriceTabModule {
}
